<div class="scopes-container">
  <!-- Header -->
  <div class="section-header">
    <div class="header-content">
      <h2>API Scopes</h2>
      <p class="section-description">Define permission scopes that can be assigned to API keys</p>
    </div>
    <button class="btn btn-primary" (click)="startCreate()" [disabled]="isCreating || isSaving">
      <i class="fas fa-plus"></i> Add Scope
    </button>
  </div>

  <!-- Messages -->
  <div class="message error-message" *ngIf="errorMessage">
    <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
  </div>
  <div class="message success-message" *ngIf="successMessage">
    <i class="fas fa-check-circle"></i> {{ successMessage }}
  </div>

  <!-- Loading State -->
  <div class="loading-container" *ngIf="isLoading">
    <i class="fas fa-spinner fa-spin"></i> Loading scopes...
  </div>

  <!-- Search -->
  <div class="filters-row" *ngIf="!isLoading">
    <div class="search-box">
      <i class="fas fa-search"></i>
      <input type="text" [(ngModel)]="searchQuery" placeholder="Search scopes..." />
    </div>
  </div>

  <!-- Create Form -->
  <div class="create-form card" *ngIf="isCreating">
    <h3>New Scope</h3>
    <div class="form-grid">
      <div class="form-group">
        <label>Name *</label>
        <input type="text" [(ngModel)]="createForm.name" placeholder="e.g., messages:read, channels:write" />
        <small class="help-text">Use a naming convention like resource:action</small>
      </div>
      <div class="form-group full-width">
        <label>Description</label>
        <textarea [(ngModel)]="createForm.description" placeholder="Describe what this scope allows" rows="2"></textarea>
      </div>
    </div>
    <div class="form-actions">
      <button class="btn btn-secondary" (click)="cancelCreate()" [disabled]="isSaving">Cancel</button>
      <button class="btn btn-primary" (click)="saveCreate()" [disabled]="isSaving">
        <i class="fas fa-spinner fa-spin" *ngIf="isSaving"></i>
        {{ isSaving ? 'Saving...' : 'Create Scope' }}
      </button>
    </div>
  </div>

  <!-- Scopes List -->
  <div class="scopes-grid" *ngIf="!isLoading">
    <div class="scope-card card" *ngFor="let sd of filteredScopes" [class.editing]="sd.isEditing">
      <!-- View Mode -->
      <ng-container *ngIf="!sd.isEditing">
        <div class="scope-header">
          <div class="scope-icon">
            <i class="fas" [ngClass]="getScopeIcon(sd.scope.Name)"></i>
          </div>
          <div class="scope-info">
            <h4>{{ sd.scope.Name }}</h4>
            <p class="scope-description">{{ sd.scope.Description || 'No description' }}</p>
          </div>
        </div>
        <div class="scope-actions">
          <button class="btn btn-icon" title="Edit" (click)="startEdit(sd)" [disabled]="isSaving">
            <i class="fas fa-edit"></i>
          </button>
          <button class="btn btn-icon btn-danger" title="Delete" (click)="confirmDelete(sd)" [disabled]="isSaving">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </ng-container>

      <!-- Edit Mode -->
      <ng-container *ngIf="sd.isEditing">
        <div class="edit-form">
          <div class="form-group">
            <label>Name</label>
            <input type="text" [(ngModel)]="sd.editForm.name" />
          </div>
          <div class="form-group">
            <label>Description</label>
            <textarea [(ngModel)]="sd.editForm.description" rows="2"></textarea>
          </div>
          <div class="form-actions">
            <button class="btn btn-secondary" (click)="cancelEdit(sd)" [disabled]="isSaving">Cancel</button>
            <button class="btn btn-primary" (click)="saveEdit(sd)" [disabled]="isSaving">
              <i class="fas fa-spinner fa-spin" *ngIf="isSaving"></i>
              Save
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Empty State -->
    <div class="empty-state card" *ngIf="filteredScopes.length === 0 && !isCreating">
      <i class="fas fa-shield-alt"></i>
      <p>No scopes defined</p>
      <button class="btn btn-primary" (click)="startCreate()">Create Your First Scope</button>
    </div>
  </div>

  <!-- Confirm Dialog -->
  <div class="modal-overlay" *ngIf="confirmDialogVisible" (click)="closeConfirmDialog()">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <h3>{{ confirmDialogTitle }}</h3>
      <p>{{ confirmDialogMessage }}</p>
      <div class="modal-actions">
        <button class="btn btn-secondary" (click)="closeConfirmDialog()">Cancel</button>
        <button class="btn btn-danger" (click)="confirmDialogYes()" [disabled]="isSaving">
          <i class="fas fa-spinner fa-spin" *ngIf="isSaving"></i>
          Delete
        </button>
      </div>
    </div>
  </div>
</div>
